<template>
    <div class="hang">

        <!-- 头部背景 -->
        <div class="hang-bgc"></div>

        <!-- 表单区域 -->
        <div class="hang-from">
            <div class="from-content">

                <!-- logo区域 -->
                <div class="from-logo">
                    <img class="from-logo-icon" :src="baseUrl + pageview.pagelogo" alt="" />
                    <div class="from-logo-tex">
                        <h1 class="logo-tex-h1">{{ pageview.title }}</h1>
                        <span class="logo-tex-span">{{ pageview.subhead }}</span>
                    </div>
                </div>

                <!-- 表单区域 -->
                <div class="from-input">
                    <div class="from-input-item">
                        <div class="input-item-left">挂号科室:</div>
                        <div class="input-item-right" @click="isoffice = true">
                            <span> {{ office || '请选择' }}</span>
                            <img class="input-item-right-icon" src="@/assets/icon/jiantou.png" alt="" srcset="">
                        </div>
                    </div>

                    <div class="from-input-item">
                        <div class="input-item-left">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名:</div>
                        <div class="input-item-right">
                            <input v-model="queryparam.uname" type="text" class="input-item-text" placeholder="请输入">
                            <img class="input-item-right-icon" src="@/assets/icon/jiantou.png" alt="" srcset="">
                        </div>
                    </div>

                    <div class="from-input-item">
                        <div class="input-item-left">性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:</div>
                        <div class="input-item-right" @click="issex = true">
                            <span>{{ queryparam.sex || '请选择' }}</span>
                            <img class="input-item-right-icon" src="@/assets/icon/jiantou.png" alt="" srcset="">
                        </div>
                    </div>

                    <div class="from-input-item">
                        <div class="input-item-left">年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;龄:</div>
                        <div class="input-item-right">
                            <input type="text" v-model="queryparam.age" class="input-item-text" placeholder="请输入">
                            <img class="input-item-right-icon" src="@/assets/icon/jiantou.png" alt="" srcset="">
                        </div>
                    </div>

                    <div class="from-input-item">
                        <div class="input-item-left">电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话:</div>
                        <div class="input-item-right">
                            <input type="text" v-model="queryparam.telephone" class="input-item-text" placeholder="请输入">
                            <img class="input-item-right-icon" src="@/assets/icon/jiantou.png" alt="" srcset="">
                        </div>
                    </div>

                    <div class="from-input-item">
                        <div class="input-item-left">就诊日期:</div>
                        <div class="input-item-right" @click="isdate = true">
                            <span>{{ queryparam.diagndata || '请选择' }}</span>
                            <img class="input-item-right-icon" src="@/assets/icon/jiantou.png" alt="" srcset="">
                        </div>
                    </div>

                    <div class="from-input-item">
                        <div class="input-item-left">就诊时间:</div>
                        <div class="input-item-right" @click="istime = true">
                            <span>{{ queryparam.diagntime || '请选择' }}</span>
                            <img class="input-item-right-icon" src="@/assets/icon/jiantou.png" alt="" srcset="">
                        </div>
                    </div>

                    <div class="from-input-submit" @click="SubmitClick">
                        提交
                    </div>
                </div>


                <!-- 注意事项 -->
                <div class="matters-need">
                    <span class="matters-need-title">挂号注意事项:</span>
                    {{ pageview.attention }}
                </div>

                <!-- 医院地理信息 -->
                <div class="matters-need">
                    <span class="matters-need-title">医院地址:</span>
                    {{ pageview.hosaddress }}
                </div>
            </div>
        </div>


        <!-- 弹框部分 -->

        <!-- 科室选择 -->
        <van-popup v-model="isoffice" position="bottom" class="van-popup-address">
            <van-picker show-toolbar value-key="officename" @confirm="onConfirmoffice" @cancel="isoffice = false"
                :columns="officelist" />
        </van-popup>

        <!-- 性别选择 -->
        <van-popup v-model="issex" position="bottom" class="van-popup-address">
            <van-picker show-toolbar @confirm="onConfirmsex" @cancel="issex = false" :columns="['男', '女']" />
        </van-popup>

        <!-- 就诊日期 -->
        <van-popup v-model="isdate" position="bottom" class="van-popup-address">
            <van-datetime-picker @cancel="isdate = false" @confirm="confirmDate" type="date" :min-date="minDate"
                :formatter="formatter" :max-date="maxDate" />
        </van-popup>

        <!-- 就诊时间 -->
        <van-popup v-model="istime" position="bottom" class="van-popup-address">
            <van-datetime-picker @cancel="istime = false" @confirm="confirmtime" type="time" :min-hour="9"
                :max-hour="18" />
        </van-popup>
    </div>
</template>

<script>
import config from "@/utils/config";
import { Toast, Dialog } from "vant"
import { getClientdataApi, addDiacrisisApi } from "@/api/reservaApi.js"
import { isPhone } from "@/utils/regexp"
export default {
    data() {
        return {
            baseUrl: config.baseUrl,
            isoffice: false,
            issex: false,
            isdate: false,
            istime: false,
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 10, 1),
            pageview: {},
            officelist: [],
            office: "",
            queryparam: {
                officeid: "",
                uname: "",
                sex: "",
                age: "",
                telephone: "",
                diagndata: "",
                diagntime: "",
                env: ""
            }
        }
    },
    created() {
        this.formatYMD()
        this.getAfterMonth()
        this.getClientdata()
    },
    methods: {
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            } else if (type === 'day') {
                return `${val}日`;
            }
            return val;
        },
        formatYMD() {
            let date = new Date()
            let y = date.getFullYear();
            let m = (date.getMonth()).toString().padStart(2, '0');
            let d = date.getDate().toString().padStart(2, '0');
            this.minDate = new Date(y, m, d);
        },
        getAfterMonth(monthNum = 1) {
            let date = new Date();
            date.setMonth(date.getMonth() + monthNum);
            let y = date.getFullYear();
            let m = (date.getMonth() + 1).toString().padStart(2, '0');
            let d = date.getDate().toString().padStart(2, '0');
            this.maxDate = new Date(y, m, d);
        },
        // 获取配置信息
        getClientdata() {
            getClientdataApi().then(res => {
                this.pageview = res.data.pageview
                this.officelist = res.data.officelist
            })
        },
        // 选中科室
        onConfirmoffice(val) {
            this.office = val.officename
            this.queryparam.officeid = val.id
            this.isoffice = false
        },
        // 选择性别
        onConfirmsex(val) {
            this.queryparam.sex = val
            this.issex = false
        },
        // 选中日期
        confirmDate(val) {
            this.isdate = false
            let date = new Date(val)
            let y = date.getFullYear();
            let m = (date.getMonth() + 1).toString().padStart(2, '0');
            let d = date.getDate().toString().padStart(2, '0');
            this.queryparam.diagndata = `${y}-${m}-${d}`
        },
        // 选择时间
        confirmtime(val) {
            this.queryparam.diagntime = val
            this.istime = false
        },
        SubmitClick() {
            if (!this.queryparam.officeid) {
                Toast('请选择你的科室！');
                return
            }
            if (!this.queryparam.uname) {
                Toast('请输入你的姓名！');
                return
            }
            if (!this.queryparam.sex) {
                Toast('请选择你的性别！');
                return
            }
            if (!this.queryparam.age) {
                Toast('请选择你的年龄！');
                return
            }
            if (!this.queryparam.telephone) {
                Toast('请输入你的电话！');
                return
            }
            if (!isPhone(this.queryparam.telephone)) {
                Toast('请输入合规的手机号码！');
                return
            }
            if (!this.queryparam.diagndata) {
                Toast('请选择你的预约日期！');
                return
            }
            if (!this.queryparam.diagntime) {
                Toast('请选择你的预约时间！');
                return
            }
            this.queryparam.env = this.$requestenv
            addDiacrisisApi(this.queryparam).then(res => {
                if (res.code == 1) {
                    Dialog.alert({
                        title: '消息提示！',
                        message: "预约成功",
                        theme: "round-button"
                    })
                        .then(() => {
                            this.queryparam = {
                                officeid: "",
                                uname: "",
                                sex: "",
                                age: "",
                                telephone: "",
                                diagndata: "",
                                diagntime: "",
                                env: ""
                            }
                            setTimeout(() => {
                                console.log(res.data)
                                this.$router.push({
                                    path: "/success",
                                    query: res.data
                                })
                            }, 500)
                        })
                } else {
                    Toast('预约失败！');
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.van-popup-address {
    border-radius: 10px 10px 0 0;
}

.hang {
    width: 100%;
    min-height: 100vh;
    background-color: #F1F1F1;

    .hang-from {
        width: 100%;
        margin-top: -260px;
        height: auto;
        padding: 0 20px;
        padding-bottom: 20px;
        box-sizing: border-box;

        .from-content {
            width: 100%;
            height: auto;
            background-color: #fff;
            padding: 20px;
            border-radius: 5px;
            box-sizing: border-box;

            .matters-need:last-of-type {
                margin-bottom: 5px !important;
            }

            .matters-need {
                width: 100%;
                font-size: 12px;
                color: #527966;
                text-align: justify;
                letter-spacing: 1px;
                margin-top: 20px;

                .matters-need-title {
                    font-size: 13px;
                    font-weight: bold;
                    color: #527966;
                }
            }

            .from-input {
                width: 100%;
                margin-top: 80px;

                .from-input-submit {
                    width: 100%;
                    height: 40px;
                    border-radius: 5px;
                    background-color: #527966;
                    text-align: center;
                    line-height: 40px;
                    color: #fff;
                    font-size: 14px;
                }

                .from-input-item {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 30px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #eee;

                    .input-item-left {
                        width: 80px;
                        font-size: 15px;
                        color: #527966;
                        font-weight: 600;
                    }

                    .input-item-right {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        color: #999;

                        .input-item-text {
                            text-align: right;
                            font-size: 14px;
                            color: #999;
                        }

                        .input-item-text::placeholder {
                            text-align: right;
                            font-size: 14px;
                            color: #999;
                        }

                        .input-item-right-icon {
                            width: 13px;
                            height: 13px;
                            margin-left: 5px;
                        }
                    }
                }
            }

            .from-logo {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .from-logo-tex {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    margin-left: 20px;

                    .logo-tex-h1 {
                        text-align: right;
                        font-size: 20px;
                        color: #527966;
                        font-weight: 600;
                    }

                    .logo-tex-span {
                        text-align: right;
                        margin-top: 8px;
                        font-size: 16px;
                        color: #527966;
                        font-weight: 500;
                    }
                }

                .from-logo-icon {
                    width: 50px;
                    height: 45px;
                }
            }
        }
    }

    .hang-bgc {
        width: 100%;
        height: 300px;
        background-color: #527966;
    }
}
</style>